import { ClickAwayListener } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { useLangSwitch } from "@ryde/redux";
import {
  appLanguageSelector,
  isCompanySelectDialogAvailableSelector,
  onActivateKeyDown,
  profileModalOpenStateAtom,
  SupportedLanguage,
  TOOLTIP_DELAY_BUTTONS,
} from "@ryde/shared";

import {
  DotsStyled,
  LangSwitchArea,
  LangSwitchStyled,
} from "./header.top.lang-switch.styled";

export const HeaderTopLangSwitch: FC = () => {
  const [isLangSelectOpen, setLangSelectIsOpen] = useState(false);
  const language = useRecoilValue(appLanguageSelector);
  const profileModalSetOpenState = useSetRecoilState(profileModalOpenStateAtom);
  const isCompanySelectDialogAvailable = useRecoilValue(
    isCompanySelectDialogAvailableSelector,
  );
  const { switchLangUpdateProfile } = useLangSwitch();

  const toggleLangSelect = (): void => {
    setLangSelectIsOpen(!isLangSelectOpen);
  };

  const closeLangSelect = (lang?: SupportedLanguage) => () => {
    setLangSelectIsOpen(false);

    if (lang) {
      switchLangUpdateProfile(lang);
    }
  };

  const openProfileScopeModal = useEvent(() => {
    profileModalSetOpenState(true);
  });

  const { t } = useTranslation();

  return (
    <>
      {isCompanySelectDialogAvailable && (
        <FramerTooltip
          content={t("general.SWITCH_COMPANY")}
          rtlStrippedBottomLeftPlacement
          tooltipDisabled={isLangSelectOpen}
          mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
        >
          <DotsStyled onClick={openProfileScopeModal}>
            <SVG_MUI.Dots9SVG />
          </DotsStyled>
        </FramerTooltip>
      )}
      <LangSwitchStyled>
        <FramerTooltip
          content={t("general.SWITCH_LANGUAGE")}
          rtlStrippedBottomRightPlacement
          tooltipDisabled={isLangSelectOpen}
          mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
        >
          <>
            {language === "he" ? (
              <SVG_MUI.LangHeSVG onClick={toggleLangSelect} />
            ) : (
              <SVG_MUI.LangSVG onClick={toggleLangSelect} />
            )}
          </>
        </FramerTooltip>

        {isLangSelectOpen && (
          <ClickAwayListener onClickAway={closeLangSelect()}>
            <LangSwitchArea onMouseLeave={closeLangSelect()}>
              <div
                className="lang_switch_item"
                role="button"
                tabIndex={0}
                aria-label="English"
                onClick={closeLangSelect("en")}
                onKeyDown={onActivateKeyDown(closeLangSelect("en"))}
              >
                <SVG_MUI.LangSVG />
              </div>
              <div
                className="lang_switch_item"
                role="button"
                tabIndex={0}
                aria-label="עברית"
                onClick={closeLangSelect("he")}
                onKeyDown={onActivateKeyDown(closeLangSelect("he"))}
              >
                <SVG_MUI.LangHeSVG />
              </div>
            </LangSwitchArea>
          </ClickAwayListener>
        )}
      </LangSwitchStyled>
    </>
  );
};
